<template>
  <BlockContainer>
    <div
      class="flex flex-col flex-grow items-center justify-center font-title uppercase Leading-none text-2-mob lg:text-3-desk"
    >
      THE PAGE YOU'RE LOOKING FOR ISN'T HERE :-(
    </div>
  </BlockContainer>
</template>

<script>
import { BlockContainer } from "@c/Block";

export default {
  name: "NotFound",

  meta: {
    title: "THE PAGE YOU'RE LOOKING FOR ISN'T HERE :-("
  },

  components: {
    BlockContainer
  }
};
</script>
